import { SelectModalItemBase } from './SelectModalItemBase';
import { SelectModalItemDefaultChecker } from './SelectModalItemChecker';
import { SelectModalItemDefault } from './SelectModalItemDefault';

const SelectModalItem = SelectModalItemBase as typeof SelectModalItemBase & {
  Default: typeof SelectModalItemDefault;
  Checker: typeof SelectModalItemDefaultChecker;
};

SelectModalItem.Default = SelectModalItemDefault;
SelectModalItem.Checker = SelectModalItemDefaultChecker;

export { SelectModalItem };
